(function(root){
  'use strict';
  function describe(cart, config) {
    const eligible = new Set(config.ids.map(String));
    const standalone = item => !item.parent_relationship && !item.properties?._pm_add_on && !item.properties?._pm_club_parent && !item.selling_plan_allocation;
    const count = (cart.items || []).reduce((n,item) => n + (standalone(item) && eligible.has(String(item.variant_id || item.id)) ? item.quantity : 0), 0);
    const optedOut = cart.attributes?._pm_club_preference === 'regular';
    const percent = optedOut ? 0 : count >= 10 ? 15 : count >= 5 ? 12 : 0;
    const code = percent ? (percent === 15 ? 'PM-LUNCH-10' : 'PM-LUNCH-5') : '';
    const groups = Object.fromEntries(Object.entries(config.groups).map(([name,g]) => [name,{...g,count:(cart.items || []).reduce((n,item) => n + (standalone(item) && g.ids.includes(String(item.variant_id || item.id)) ? item.quantity : 0),0)}]));
    const extras = Object.values(groups).reduce((n,g)=>n+g.count,0);
    const extraPercent = extras >= 6 ? 15 : extras >= 4 ? 10 : extras >= 2 ? 5 : 0;
    return {count,optedOut,percent,code,groups,extras,extraPercent,target:count<5?5:10};
  }
  function codes(cart, desired) {
    const retained = (cart.discount_codes || []).map(d=>d.code).filter(c=>c && !/^PM-LUNCH-(5|10)$/i.test(c));
    return [...new Set([...retained,...(desired?[desired]:[])])];
  }
  root.PurefectClubPolicy={describe,codes};
  if(typeof module !== 'undefined') module.exports=root.PurefectClubPolicy;
})(typeof window === 'undefined' ? globalThis : window);
